import { BaseSocket } from "./BaseSocket";
import { NodeSocket } from "./types";

export const isBaseSocket = (socket: NodeSocket): socket is BaseSocket => {
  return socket instanceof BaseSocket;
};
